import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
} from "chart.js";
import { Chart } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
);

export default function CollectionTargetAchvBarChart({ data = [] }) {
  const safeData = Array.isArray(data) ? data : [];

  const labels = safeData.map(d => d.week);
  const targetValues = safeData.map(d => Number(d.target || 0));
  const receivedValues = safeData.map(d => Number(d.received || 0));

  const maxValue = Math.max(...targetValues, ...receivedValues, 0);

  /* ================= CHART DATA ================= */
  const chartData = {
    labels,
    datasets: [
      {
        label: "Collection Target",
        data: targetValues,
        backgroundColor: "#7b003f",
        borderRadius: 6,

        // ✅ GAP BETWEEN BARS
        categoryPercentage: 1,
        barPercentage: 0.85
      },
      {
        label: "Collection Received",
        data: receivedValues,
        backgroundColor: "#f5b400",
        borderRadius: 6,

        // ✅ GAP BETWEEN BARS
        categoryPercentage: 1,
        barPercentage: 0.85
      }
    ]
  };

  /* ================= OPTIONS ================= */
  const options = {
    responsive: true,
    maintainAspectRatio: false,

    plugins: {
      legend: {
        position: "top",
        labels: { font: { size: 12 } }
      },
      tooltip: {
        backgroundColor: "#ffffff",
        titleColor: "#333",
        bodyColor: "#333",
        borderColor: "#ddd",
        borderWidth: 1,
        padding: 10,
        callbacks: {
          label: (ctx) => {
            const value = Number(ctx.raw || 0);
            return `${ctx.dataset.label}: ${(value / 1000).toFixed(1)}K`;
          }
        }
      }
    },

    scales: {
      x: {
        grid: { display: false },
        ticks: { font: { size: 12 } }
      },
      y: {
        beginAtZero: true,
        suggestedMax: Math.ceil(maxValue * 1.2),
        ticks: {
          font: { size: 12 },
          callback: (value) => `${(value / 1000).toFixed(0)}K`
        },
        grid: {
          color: "rgba(0,0,0,0.08)",
          drawBorder: false
        }
      }
    }
  };

  if (!safeData.length) {
    return (
      <div
        style={{
          height: 260,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#777"
        }}
      >
        No data
      </div>
    );
  }

  return (
    <div
      style={{
        position: "relative",
        padding: 18,
        borderRadius: 12,
        background: "#fff",
        boxShadow: "0 10px 20px rgba(0,0,0,0.08)"
      }}
    >
      <div style={{ height: 260 }}>
        <Chart type="bar" data={chartData} options={options} />
      </div>
    </div>
  );
}
